import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { Reviews } from "@/components/HomeSections";
import { ComingSoon } from "@/components/ComingSoon";
import { SectionTitle } from "@/components/Wave";
import { useSeo } from "@/lib/seo";
import { SEO } from "@/data/seo";
import { FilterBar, FilterResults } from "@/components/ShopFilters";
import { CategoryTabs, CategoryView } from "@/components/ShopCategories";
import { LoyaltyLine } from "@/components/ProductExtras";

export default function Shop() {
  useSeo(SEO.shop);
  const { products } = useStore();
  const { hash } = useLocation();
  const [filter, setFilter] = useState("");
  const [cat, setCat] = useState("");
  useEffect(() => {
    if (hash && products.length) setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 50);
  }, [hash, products.length]);
  return (
    <div data-testid="shop-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 sm:pt-16">
        <SectionTitle as="h1" chip="Shop" title="The Grandpa Finn's duo" sub="Omega-3 Fish Oil and a Daily Multivitamin. Two easy habits, zero overthinking." />
        {products.length > 0 && <CategoryTabs active={cat} onChange={(k) => { setCat(k); setFilter(""); }} />}
        {products.length > 0 && <FilterBar active={filter} onChange={setFilter} />}
        {products.length > 0 && <LoyaltyLine testId="shop-loyalty-line" className="mt-6" />}
      </div>
      {filter ? <FilterResults products={products} active={filter} /> : <>
      {!products.length && <div className="max-w-7xl mx-auto px-4 py-10"><div className="h-96 animate-pulse rounded-2xl bg-white sticker" /></div>}
      <CategoryView products={products} active={cat} />
      {!cat && <ComingSoon />}
      </>}
      <Reviews />
    </div>
  );
}
